import script from "./marketingCall.vue?vue&type=script&setup=true&lang=ts"
export * from "./marketingCall.vue?vue&type=script&setup=true&lang=ts"

import "./marketingCall.vue?vue&type=style&index=0&id=9336b152&lang=css"

const __exports__ = script;

export default __exports__